import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16 0h2v3h3v2h-3v3h-2V5h-3V3h3V0ZM10 3.016a7.5 7.5 0 1 0 5.05 13.447l4.535 4.536L21 19.585l-4.537-4.537A7.463 7.463 0 0 0 17.983 11h-2.005A5.5 5.5 0 1 1 10 5.022V3.016Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }